import TabNav from "components/TabNav";
import React, { useState } from "react";
import {
    LEGAL_RESEARCH_PROSECUTOR_TAB,
    LEGAL_RESEARCH_PROSECUTOR_TABS, LEGAL_RESEARCH_REQUEST_STATUS,
} from "utils/constantValues";
import LeftPanel from "./fragments/leftPanel";
import RightPanel from "./fragments/rightPanel";

interface CoordinatorLegalResearchProps {
    request: any;
}

const CoordinatorConductLegalResearch: React.FC<
    CoordinatorLegalResearchProps
> = ({ request }) => {
    const [activeTab, setActiveTab] = useState<string>("Proposal Document");
    const [formState, setFormState] = useState({
        ...request,
        urgency_level: request?.urgency_level
            ? request?.urgency_level.charAt(0).toUpperCase() +
            request?.urgency_level.slice(1).toLowerCase()
            : "High",
    });

    return (
        <div className="flex flex-col h-full bg-gray-100">
            {formState.requested_by !== "internal" && <TabNav
                active={activeTab}
                tabs={(formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.research_underway.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.draft_submitted.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.draft_revision.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.draft_approved.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.completed.value || formState?.documents.find((document: any) => document.document_type === "research_draft_file")) ?
                    LEGAL_RESEARCH_PROSECUTOR_TABS : LEGAL_RESEARCH_PROSECUTOR_TAB}
                onSelect={setActiveTab}
            />}
            <div className="flex flex-1 overflow-hidden">
                <LeftPanel activeTab={activeTab} request={request} showBroadcast={false} onBroadcast={undefined} />
                <RightPanel request={request} />
            </div>
        </div>
    );
};

export default CoordinatorConductLegalResearch;

